import VMSView from '../index.web';

/** Displays the shared camera viewer inside the dashboard widget shell. */
export default function VMSWidget({ widgetRuntime }) {
  return <VMSView compact widgetRuntime={widgetRuntime} />;
}
